const defaultPalette = {
  neutral: {
    shade1: '#F5F7FD',
  },
};

export const baseTheme = {
  palette: defaultPalette,
};

type DefaultTheme = typeof baseTheme;

const getNotificationsTheme = (theme: DefaultTheme) => ({
  background: {
    hover: theme.palette.neutral.shade1,
  },
  border: {
    main: theme.palette.neutral.shade1,
  },
  padding: {
    main: '16px 24px',
    anchor: '0 24px 4px',
  },
});

export { getNotificationsTheme };
